define.alias("shared/components/shared/enterprise-modal", "calendar/components/shared/enterprise-modal");